/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CancelAction from './CancelAction/index'
import React from 'react'
import SubmitAction from './SubmitAction/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2Warning from 'DesignSystem/Svgs/Tysiav2Warning/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Edit/RegenerateLetterModal/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsYellow600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.yellow.600'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Regenerate letter"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 alignItems="center"
 justifyContent="center"
 position="relative"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Tysiav2Warning
  viewPath={`${viewPath}/Tysiav2Warning`}
 fill2={dtColorsYellow600}
 height={48}
 width={48}
/>
</div>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 marginTop={dtSpaceM}
 size="normal"
 weight="medium"
 color={dtColorsNeutral900}
 text="Are you sure you want to regenerate the letter?"
/>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="normal"
 weight="medium"
 color={dtColorsNeutral500}
 text="Any changes made to previous letter will not change."
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
{...childProps}
  viewPath={`${viewPath}/SubmitAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}